import ManageUsersComponent from "./ManageUsersComponent"

const AdminUsersComponent = () => {
    return (
    <section className="min-h-screen">
        <h2 className="text-2xl font-semibold mb-2">Manage Users</h2>
        <p className="text-red-900 bg-red-100 p-6 max-w-2xl mx-auto text-center font-semibold">
            View users, remove users, assign roles, and manage access.
        </p>
        <ManageUsersComponent/>
    </section>
    )
}

export default AdminUsersComponent